import { AutopilotTaskDto } from '@urbanx/agx.activities.client';
import { IconTaskTypes } from '@urbanx/agx.ui-components2';
import TaskDueDateBadge from 'components/tasks/TaskDueDateBadge';
import TaskCompletionConfirmationModal from 'pages/allTasks/TaskModal/TaskCompletionConfirmationModal';
import TaskModalEntry from 'pages/allTasks/TaskModal/TaskModalEntry';
import { useTaskModalDialogState } from 'pages/allTasks/TaskModal/useTaskModalDialogState';
import { JSX, useState } from 'react';
import { getStepsCompletionInfo } from 'utils/tasks';
import ContractComplianceModal from './ContractComplianceModal';

interface ContractComplianceProps {
  campaignId: string;
  tasks: AutopilotTaskDto[];
}

const ContractCompliance = ({ campaignId, tasks }: ContractComplianceProps) => {
  const modalState = useTaskModalDialogState(tasks);
  const [showCompletionConfirmation, setShowCompletionConfirmation] = useState(false);
  const { allStepsCompleted, latestCompletedDate } = getStepsCompletionInfo(tasks);

  const dueDate =
    tasks
      .flatMap((task) => {
        const dateValue = allStepsCompleted ? latestCompletedDate : task.dueUtc;

        return dateValue ? [new Date(dateValue)] : [];
      })
      .sort((a, b) => a.getTime() - b.getTime())[0] ?? '';

  const badge: JSX.Element = (
    <TaskDueDateBadge
      dueDate={dueDate}
      isCompleted={allStepsCompleted}
      completedDate={latestCompletedDate}
    />
  );

  return (
    <>
      <ContractComplianceModal
        campaignId={campaignId}
        isOpen={modalState.isOpen}
        onClose={modalState.close}
        onCompleteSuccess={() => setShowCompletionConfirmation(true)}
        tasks={modalState.modalTasks}
      />
      <TaskModalEntry
        title="Contract Compliance"
        tasks={tasks}
        badge={badge}
        iconType={IconTaskTypes.AgreementCompliance}
        actionText="Complete Compliance Check"
        actionButtonId="completeContractComplianceCheckBtn"
        panelKey="ContractCompliancePanel"
        onAction={modalState.open}
      />
      <TaskCompletionConfirmationModal
        isOpen={showCompletionConfirmation}
        onOpenChange={setShowCompletionConfirmation}
        title="Contract Compliance now complete"
        message="Contract will be emailed to all parties"
      />
    </>
  );
};

export default ContractCompliance;
